import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import SecuritySettings from "./Components/AccountSettings/SecuritySettings";
import Password from "./Components/AccountSettings/Password";
import EmailNotification from "./Components/AccountSettings/EmailNotification";
import DeleteAccount from "./Components/AccountSettings/DeleteAccount";
import { Link, useParams, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { getuserdata } from "../../../services/apiService";
import { oneKlicks } from "../../../SDK/oneclick";
import { toast } from "react-toastify";
import { debugLog } from "../../../utils/debug";

const AccountSettings = () => {
    const [userdata, setUserdata] = useState({});
    const { sublink } = useParams();
    const [tabsest, setTabseset] = useState("Security & Settings");
    const navigate = useNavigate();

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        debugLog("userData", userData);
        if (userData) {
            setUserdata(userData);
        }
    }, []);

    useEffect(() => {
        if (sublink === "Security_&_Settings") {
            setTabseset("Security & Settings");
        } else if (sublink === "Password") {
            setTabseset("Password");
        } else if (sublink === "Email_Notification") {
            setTabseset("Email Notification");
        }
    }, [sublink]);

    // Tab to URL mapping
    const tabToUrlMapping = {
        "Security & Settings": "Security_&_Settings",
        "Password": "Password",
        "Email Notification": "Email_Notification",
        "Delete Account": "Delete_Account"
    };

    const handleTabClick = (tabName) => {
        setTabseset(tabName);
        const urlPath = tabToUrlMapping[tabName];
        if (urlPath) {
            navigate(`/pharmacy/accountsettings/${urlPath}`);
        }
    };

    const [oldpassword, setOldpassword] = useState("");
    const [newpassword, setNewpassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");
    const [email, setEmail] = useState("");
    const [oldemail, setOldemail] = useState("");
    const [emailisvalid, setEmailisvalid] = useState(false);

    const [formData, setFormData] = useState({
        password: '',
        retypePassword: '',
        reason: '',
        description: ''
    });

    useEffect(() => {
        const fetchEmail = async () => {
            const emailData = await getuserdata("email");
            const emailisvalid = await getuserdata("activation_key");
            debugLog('getuserdata email', emailData);
            debugLog('getuserdata emailisvalid', emailisvalid);
            setEmail(emailData);
            setOldemail(emailData);
            setEmailisvalid(emailisvalid);
        };
        
        fetchEmail();
    }, []);

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        
        // Password validation
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(newpassword)) {
            toast.error("Password must be at least 8 characters long and contain uppercase, lowercase, number and special character");
            return;
        }

        if (newpassword !== confirmpassword) {
            toast.error("New password and confirm password do not match");
            return;
        }

        try {
            const oldpasswordhash = CryptoJS.SHA256(oldpassword).toString();
            const newpasswordhash = CryptoJS.SHA256(newpassword).toString();

            const tableSchema = "";
            const tableName = "users";
            const conditions = {
                "email": await getuserdata("email"),
                "pass": oldpasswordhash
            };
            const orderBy = "id DESC";
            const search = null;
            const pagination = null;
            const margedata = null;

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            debugLog("response check paswors", response);
            if (response.success && response.data.length > 0) {
                const data = {
                    "pass": newpasswordhash
                };
                const condition = {
                    "email": await getuserdata("email")
                };
                const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
                
                if (updateData.success) {
                    toast.success("Password updated successfully");
                    // Clear password fields
                    setOldpassword("");
                    setNewpassword("");
                    setConfirmpassword("");
                } else {
                    toast.error("Failed to update password. Please try again.");
                }
            } else {
                toast.error("Current password is incorrect");
            }
        } catch (error) {
            toast.error("An error occurred while updating password");
        }
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        debugLog('Email', email);
        const tableSchema = "";
        const tableName = "users";
        const conditions = {
            "email": oldemail
        };
        const orderBy = "id DESC";
        const search = null;
        const pagination = null;
        const margedata = null;
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('response check email', response);
        if (response.success && response.data.length > 0) {
            const data = {
                "email": email
            };
            const condition = {
                "email": oldemail,
                "activation_key": "0"
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (updateData.success === true) {
                toast.success("Email updated successfully");
            } else {
                toast.error("Failed to update email. Please try again.");
            }
            debugLog('updateData check email', updateData);
        } else {
            toast.error("Email not found");
        }
    };

    const handleDeleteAccount = async (e) => {
        e.preventDefault();
        const passwordhash = CryptoJS.SHA256(formData.password).toString();
        debugLog('formData', formData);
        const tableSchema = "";
        const tableName = "users";
        const conditions = {
            "email": await getuserdata("email"),
            "pass": passwordhash   
        };
        const orderBy = "id DESC";
        const search = null;
        const pagination = null;
        const margedata = null;
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('response check delete account', response);
        if (response.success && response.data.length > 0) {
            const data = {
                "status": "2" // 2 is for deleted account
            };
            const condition = {
                "email": await getuserdata("email"),
                "pass": passwordhash
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            debugLog('updateData check delete account', updateData);
            if (updateData.success) {
                const tableSchema = "";
                const tableName = "user_delete_requests";
                const data = {
                    "reason": formData.reason,
                    "description": formData.description,
                    "status": "2",
                    "user_id": await getuserdata("id"),
                    "email": await getuserdata("email"),
                    "deleted_at": new Date().toISOString(),
                    "phone": await getuserdata("phone")
                };
                const condition = {
                    "user_id": await getuserdata("id")
                };
                const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
                debugLog('updateData check delete account', updateData);
                if (updateData.success) {
                    toast.success("Account deleted successfully");
                    localStorage.removeItem("userData");
                    navigate("/");
                } else {
                    toast.error("Failed to delete account. Please try again.");
                }
            } else {
                toast.error("Failed to delete account. Please try again.");
            }
        } else {
            toast.error("Invalid password");
        }
    };

    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {userdata.activation_key == null && (
                    <EmailVerify />
                )}

                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <form className="dc-haslayout dc-user-account">
                                <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder">
                                    <div className="dc-dashboardtabs">
                                        <ul className="dc-tabstitle nav navbar-nav">
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Security & Settings" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Security & Settings");
                                                }}>
                                                    Security &amp; Settings
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Password" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Password");
                                                }}>
                                                    Password
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Email Notification" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Email Notification");
                                                }}>
                                                    Email Notification
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Delete Account" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Delete Account");
                                                }}>
                                                    Delete Account
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    {tabsest == "Security & Settings" && (
                                      <SecuritySettings/>  
                                    )}
                                    {tabsest == "Password" && (
                                      <Password oldpassword={oldpassword} setOldpassword={setOldpassword} newpassword={newpassword} setNewpassword={setNewpassword} confirmpassword={confirmpassword} setConfirmpassword={setConfirmpassword}/>  
                                    )}
                                    {tabsest == "Email Notification" && (
                                      <EmailNotification email={email} onEmailChange={setEmail} emailisvalid={emailisvalid}/>  
                                    )}
                                    {tabsest == "Delete Account" && (
                                      <DeleteAccount formData={formData} setFormData={setFormData}/>  
                                    )}
                                </div>

                                <div className="dc-updatall">
                                    <i className="ti-announcement"></i>
                                    <span>Update all the latest changes made by you, by just clicking on Save &amp; Update button.</span>
                                    <a className="dc-btn dc-update-account22" data-id="41742" data-post="181282" href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (tabsest === "Password") {
                                            handlePasswordSubmit(e);
                                        } else if (tabsest === "Email Notification") {
                                            handleEmailSubmit(e);
                                        } else if (tabsest === "Delete Account") {
                                            handleDeleteAccount(e);
                                        }
                                    }}
                                    >Save &amp; Update</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AccountSettings;
